import { useState } from 'react';

import ColourFilter from './colourFilter';
import FeaturesFilter from './featuresFilter';
import InstantSearchFiltersModal from './instantSearchFiltersModal';
import InstantSearchSort from './instantSearchSort';
import InstantSearchToggle from './units/instantSearchToggle';
import LocationFilter from './locationFilter';
import MakeFilter from './makeFilter';
import ModelVariantFilter from './modelVariantFilter';
import MultiSelectFilter from './multiSelectFilter';
import PaymentFilter from './paymentFilter';
import EngineSizeFilter from './engineSizeFilter';
import SingleSelectFilter from './singleSelectFilter';
import SingleSelectNumericFilter from './singleSelectNumericFilter';
import VirtualFilters from './virtualFilters';

import useFilterScrollPositionManager from '../hooks/useFilterScrollPositionManager';

import { DEFAULT_FILTERS_SCHEMA, MOTAB_FILTERS_SCHEMA } from './schema';

import type { FilterTypeProps, FilterSchema, FilterType } from './schema';
import type { HasMotabilityState } from '@javascript/types/InstantSearch';

const filters: { [K in FilterType]: React.FC<FilterTypeProps<K>> } = {
  colour: ColourFilter,
  engine: EngineSizeFilter,
  features: FeaturesFilter,
  location: LocationFilter,
  make: MakeFilter,
  modelVariant: ModelVariantFilter,
  multi: MultiSelectFilter,
  numeric: SingleSelectNumericFilter,
  payment: PaymentFilter,
  single: SingleSelectFilter,
  toggle: InstantSearchToggle,
};

const Filter = <T extends FilterType>(props: FilterSchema<T>) => {
  const { filterType, ...rest } = props;
  const FilterComponent = filters[filterType] as React.FC<FilterTypeProps<T>>;
  return <FilterComponent {...(rest as FilterTypeProps<T>)} />;
};

const InstantSearchFilters = ({ isMotability }: HasMotabilityState) => {
  const [filtersOpen, setFiltersOpen] = useState(false);

  const { filtersModalRef, filtersRef } = useFilterScrollPositionManager();

  return (
    <InstantSearchFiltersModal onModalToggle={setFiltersOpen}>
      <main className="ch-modal__body" ref={filtersModalRef}>
        <div className="ch-bg--grey-1" ref={filtersRef}>
          <InstantSearchSort isMotability={isMotability} />
          {Object.entries(
            isMotability ? MOTAB_FILTERS_SCHEMA : DEFAULT_FILTERS_SCHEMA
          ).map(([key, schema]) => (
            <Filter filtersOpen={filtersOpen} key={key} {...schema} />
          ))}
          <VirtualFilters />
        </div>
      </main>
    </InstantSearchFiltersModal>
  );
};

export default InstantSearchFilters;
